import React, { useState, useEffect } from 'react';
import { Layout, Menu, Button, Drawer } from 'antd';
import { MenuOutlined } from '@ant-design/icons';

const { Header: AntHeader } = Layout;

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    handleResize(); // Check initial size
    window.addEventListener('resize', handleResize);
    
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  // Streamlined menu - removed some sections to reduce density
  const menuItems = [
    {
      key: 'about',
      label: 'About',
      onClick: () => scrollToSection('about'),
    },
    {
      key: 'experience',
      label: 'Experience',
      onClick: () => scrollToSection('experience'),
    },
    {
      key: 'projects',
      label: 'Projects',
      onClick: () => scrollToSection('projects'),
    },
    {
      key: 'publications',
      label: 'Publications',
      onClick: () => scrollToSection('publications'),
    },
    {
      key: 'education',
      label: 'Education',
      onClick: () => scrollToSection('education'),
    },
    {
      key: 'news',
      label: 'News',
      onClick: () => scrollToSection('news'),
    },
    {
      key: 'contact',
      label: 'Contact',
      onClick: () => scrollToSection('contact'),
    },
  ];

  return (
    <>
      <AntHeader 
        style={{ 
          position: 'fixed', 
          zIndex: 1000, 
          width: '100%',
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
          borderBottom: '1px solid #f0f0f0',
          padding: '0 16px',
          height: '64px',
          lineHeight: '64px'
        }}
      >
        <div style={{ 
          maxWidth: '1200px', 
          margin: '0 auto', 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          height: '100%'
        }}>
          <div style={{ 
            fontSize: '1.5rem', 
            fontWeight: 'bold', 
            color: '#1890ff',
            cursor: 'pointer'
          }} onClick={() => scrollToSection('home')}>
            KE
          </div>
          
          {/* Desktop Menu */}
          {!isMobile && (
            <Menu
              mode="horizontal"
              items={menuItems}
              style={{ 
                border: 'none',
                background: 'transparent',
                flex: 1,
                minWidth: 0,
                justifyContent: 'center'
              }}
              theme="light"
            />
          )}
          
          {/* Mobile Menu Button */}
          {isMobile && (
            <Button
              type="text"
              icon={<MenuOutlined />}
              onClick={() => setIsMobileMenuOpen(true)}
              style={{
                color: '#1890ff',
                fontSize: '18px',
                border: 'none',
                background: 'transparent'
              }}
            />
          )}
        </div>
      </AntHeader>

      {/* Mobile Drawer */}
      <Drawer
        title="Menu"
        placement="right"
        onClose={() => setIsMobileMenuOpen(false)}
        open={isMobileMenuOpen}
        width={280}
        style={{ zIndex: 1001 }}
      >
        <Menu
          mode="vertical"
          items={menuItems}
          style={{ 
            border: 'none',
            background: 'transparent'
          }}
        />
      </Drawer>
    </>
  );
};

export default Header;